import { reactEvents } from '../../../bridge/reactEvents';
import { navigationStore } from '../../../bridge/navigationStore';

// @ngInject
const scrollTop = ($window) => {
  $window.scrollTo(0, 0);
};

// @ngInject
const customerResolve = ($stateParams, CustomersApiService) =>
  CustomersApiService.getById($stateParams.customerId);

// @ngInject
const rootFolderIdResolve = (customer) => customer.folderId;

// @ngInject
const config = ($stateProvider) => {
  $stateProvider.state('customer', {
    parent: 'main',
    url: '/customers/{customerId}',
    views: {
      'main-content': {
        controller: 'CustomerController as vm',
        templateUrl: 'main/customer/customer.tpl.html',
      },
    },
    data: { pageTitle: 'Customer' },
    resolve: {
      customer: customerResolve,
    },
    onEnter: scrollTop,
  });
  // Articles tab
  $stateProvider.state('customer.articles', {
    url: '/articles',
    templateUrl: 'tabs/articlesTab/articlesTab.tpl.html',
    controller: 'ArticlesTabController as vm',
    resolve: {
      concept: () => null,
    },
    params: {
      filterByConceptId: null,
    },
  });
  $stateProvider.state('customer.productApprovals', {
    url: '/product-approvals?searchTerm&supplierId&branchId&state&sampleState',
    template:
      '<customer-product-approvals customer-id="vm.customer.id"></customer-product-approvals>',
  });
  // Concepts tab
  $stateProvider.state('customer.concepts', {
    url: '/concepts',
    templateUrl: 'tabs/conceptsTab/conceptsTab.tpl.html',
    controller: 'ConceptsTabController as vm',
  });
  $stateProvider.state('customer.complianceDocuments', {
    url: '/certs-reports',
    templateUrl:
      'main/customer/complianceDocuments/complianceDocuments.tpl.html',
  });
  // Files tab
  $stateProvider.state('customer.files', {
    url: '/files',
    abstract: true,
    templateUrl: 'tabs/filesTab/filesTab.tpl.html',
    controller: 'FilesTabsController as vm',
    resolve: {
      rootFolderId: rootFolderIdResolve,
      isArticle: () => false,
      article: () => null,
      concept: () => null,
      supplier: () => null,
    },
  });
  $stateProvider.state('customer.files.id', {
    url: '/{folderPath:nonURIEncoded}',
    params: {
      folderPath: { value: null, squash: true },
    },
  });
  // Tasks tab
  $stateProvider.state('customer.tasks', {
    url: '/tasks',
    templateUrl: 'tabs/tasksTab/tasksTab.tpl.html',
    controller: 'TasksTabsController as vm',
    resolve: {
      article: () => null,
      concept: () => null,
      tasksTabSettings: () => null,
    },
  });
};

class CustomerController {
  constructor($rootScope, $scope, $state, customer) {
    'ngInject';

    $rootScope.pageTitle = `${customer.name || ''} - Customer`;
    reactEvents.entityVisited.dispatch({
      id: customer.id,
      type: 'customer',
      label: customer.name,
      customerId: customer.id,
    });

    this.$state = $state;
    this.$scope = $scope;
    this.customer = customer;

    this.entityTabs = [
      {
        heading: '<i class="icon icon-settings"></i>',
        tooltip: 'Management',
        route: 'customer.management',
      },
      {
        heading: '<i class="icon icon-folder"></i>',
        tooltip: 'Files',
        route: 'customer.files.id',
      },
      {
        heading: '<i class="icon icon-assignment"></i>',
        tooltip: 'Tasks',
        route: 'customer.tasks',
      },
    ];

    this.contentTabs = [
      {
        isDefault: true,
        active: $state.is('customer'),
        heading: 'Articles',
        route: 'customer.articles',
      },
      {
        heading: 'Product approvals',
        route: 'customer.productApprovals',
      },
      {
        heading: 'Concepts',
        route: 'customer.concepts',
      },
      {
        heading: 'Team',
        route: 'customer.users',
      },
      // Hide this for now until out of beta
      //   {
      //     heading: 'Users',
      //     route: 'customer.external',
      //   },
      {
        heading: 'Contacts',
        route: 'customer.contacts',
      },
    ];

    this.publishNavigationContext();

    this.customerArchived = reactEvents.customerArchived.subscribe(
      (customerId) => {
        if (customerId === this.customer.id) {
          this.customer.archived = true;
          this.publishNavigationContext();
          this.$scope.$applyAsync();
        }
      },
    );

    this.customerRestored = reactEvents.customerRestored.subscribe(
      (customerId) => {
        if (customerId === this.customer.id) {
          this.customer.archived = false;
          this.publishNavigationContext();
          this.$scope.$applyAsync();
        }
      },
    );

    this.customerNameChanged = reactEvents.customerNameChanged.subscribe(
      (customer) => {
        if (customer.id === this.customer.id) {
          this.customer.name = customer.value;
          this.publishNavigationContext();
          this.$scope.$applyAsync();
        }
      },
    );

    $scope.$on('$stateChangeSuccess', () => {
      if (this.$state.is('customer')) {
        this.goToDefaultState();
      }
    });

    this.$scope.$on('$destroy', () => {
      this.customerArchived();
      this.customerRestored();
      this.customerNameChanged();
    });
  }

  goToDefaultState() {
    const initialTab = _.find(this.contentTabs, { isDefault: true });
    if (initialTab) {
      this.$scope.$applyAsync(() => {
        this.$state.go(initialTab.route, initialTab.params?.(), {
          location: 'replace',
        });
      });
    }
  }

  publishNavigationContext() {
    navigationStore.setContext({
      type: 'customer',
      customer: {
        id: this.customer.id,
        name: this.customer.name,
        archived: this.customer.archived,
      },
    });
  }
}

angular
  .module('main.customer', [
    'main.customer.management',
    'main.customer.users',
    'main.customer.contacts',
    'main.customer.external',
  ])
  .config(config)
  .controller('CustomerController', CustomerController);
